module.exports = __webpack_public_path__ + "static/media/4f15e46a-4298-0ef6-05a3-b662236b10b8.2c82c850.jpg";